module.exports = __webpack_public_path__ + "img/game-corner.40987745.png";